package org.dronda.app.web.ui.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.github.michaelbull.result.Result
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.gridTemplateRows
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

private val defaultContainerModifier = Modifier
    .display(DisplayStyle.Grid)
    .gridTemplateRows {
        // auto minmax(1.5rem, 1fr) minmax(1rem, auto)
        size(auto)
        minmax(1.5.cssRem, 1.fr)
        minmax(1.cssRem, auto)
    }
    .gap(0.5.cssRem)

@Composable
fun ControlledInput(
    textState: MutableState<String>,
    label: String,
    labelId: String,
    disabled: Boolean = false,
    rule: ((value: String) -> Result<String, String>)? = null,
    maxLength: Int? = null,
    inputType: InputType<String> = InputType.Text,
    modifier: Modifier = Modifier
) {
    var text: String by remember { textState }
    var touched by remember { mutableStateOf(false) }

    Div(defaultContainerModifier.then(modifier).toAttrs()) {
        Label(labelId) { Text(label) }
        Input(inputType) {
            style {
                padding(0.5.cssRem)
                borderRadius(2.px)
                property("width", "100%")
                property("box-sizing", "border-box")
                border {
                    style = LineStyle.Solid
                    width = 1.px
                    color = rgb(176, 176, 176)
                }
            }
            value(text)
            onInput { event ->
                if (maxLength != null && event.value.length > maxLength) {
                    // ignore
                } else {
                    text = event.value
                }
                touched = true
            }
            if (disabled) { disabled() }
        }
        if (rule != null && touched && rule(text).isErr) {
            P({
                style { color(Color.red) }
            }) {
                Text("Text contains invalid characters.")
            }
        }
    }
}
